import { Badge } from "@devhop/ui";
import { formatPrivateLessonBookingPlace } from "@/modules/private-lessons/domain/lib/booking-display";
import {
  offSiteDistanceFullLabel,
  type OffSiteDistance,
} from "@/modules/private-lessons/domain/lib/off-site-distance";

type PrivateLessonBookingLocationCellProps = {
  locationKind?: "studio" | "off_site" | null;
  offSiteLabel?: string | null;
  offSiteDistance?: OffSiteDistance | null;
  roomName?: string | null;
};

export function PrivateLessonBookingLocationCell({
  locationKind,
  offSiteLabel,
  offSiteDistance,
  roomName,
}: PrivateLessonBookingLocationCellProps) {
  if (locationKind === "off_site") {
    const label = offSiteLabel?.trim();
    const distanceLabel = offSiteDistance
      ? offSiteDistanceFullLabel(offSiteDistance)
      : null;
    return (
      <div className="flex flex-wrap items-center gap-1.5">
        <Badge variant="outline">
          {distanceLabel ?? "ນອກສະຖານທີ່"}
        </Badge>
        {label ? <span className="text-sm">{label}</span> : null}
      </div>
    );
  }

  return (
    <span>{formatPrivateLessonBookingPlace({ locationKind, roomName })}</span>
  );
}
